<template>
  <my-view :GetOrderInfoToPay="GetOrderInfoToPay" :GetOrderPayFeeInfo="GetOrderPayFeeInfo" :PageOrderPay="PageOrderPay"></my-view>
</template>

<script>
import {
  GetOrderInfoToPay,
  GetOrderPayFeeInfo,
  PageOrderPay,
} from "@/pages/page1/api/modules/order";

import MyView from "@/pages/publicView/paymentProcess/payType/payType_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetOrderInfoToPay,
      GetOrderPayFeeInfo,
      PageOrderPay,
    };
  },
};
</script>